var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    fill: "#0E89BC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.5535 60.8784H22V49.5981H28.9897",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.3923 38.9851L28.9417 42.5388L35.2598 36.2206",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.8486 46.0751H22V34.7992H30.6902",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.3923 24.1862L28.9417 27.7356L35.2598 21.4218",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.7032 31.2759H22V20H30.6902",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M58.5791 34.5241L53.6912 29.6405",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38.8134 44.5181C35.3731 47.9584 32.6348 52.031 30.7511 56.5178L30.738 56.5527C30.629 56.8143 30.6857 57.1195 30.8906 57.3201C31.0912 57.5207 31.3964 57.5817 31.6581 57.4727C36.171 55.589 40.2698 52.8376 43.7275 49.3842L60.5455 32.5663C61.4829 31.6288 61.4829 30.1071 60.5455 29.1652L59.0586 27.6783C58.1211 26.7409 56.5993 26.7409 55.6575 27.6783L38.8134 44.5224V44.5181Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M60.0439 33.0591L61.5395 34.5547C62.368 35.3832 62.477 36.6825 61.8055 37.6418L61.7967 37.6549C60.4276 39.5953 58.6573 41.213 56.5992 42.399L56.5076 42.4513L56.464 42.4382C54.7329 42.0066 53.1501 43.5414 53.5295 45.2855L53.5557 45.4033L51.6851 47.2739",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M58.2126 27.0986L60.5585 24.7528C61.1472 24.1641 62.0977 24.1641 62.6864 24.7528L63.5585 25.6248C64.1471 26.2135 64.1471 27.164 63.5585 27.7527L61.2126 30.0986",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M43.3699 49.5282L38.6128 44.7667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmark-icon.59515aeb643e8e56bd64fea408f9e28f.svg";
export { ForwardRef as ReactComponent };